import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';

function useH5() {
  const [isH5, setIsH5] = useState(window.screen.width < 500)

  return [isH5]
}

export default useH5